<template>
  <div style="width: 100%" v-if="!this.$parent.isLoadShow">
    <!-- navbar -->
    <b-navbar toggleable="lg" type="light" variant="" class="">
      <b-navbar-brand>
        <div style="display: flex; align-items: center;">
          <i class="rs-icon-default rs-icon-logo rs-icon-title-color"></i>
          <div style="color: #032313; padding-left: 13px;">儲值方案</div>
        </div>
      </b-navbar-brand>
    </b-navbar>
    <!-- content -->
    <div class="rs-account-profile-content-sty">
      <div v-if="planInfo.orderId">
        <h5>選擇您的方案</h5>
        <h6 v-if="planInfo.cash">這次服務還須補足 <span style="color: #a06f6c">{{planInfo.cash}}</span></h6>
      </div>
      <div v-for="(plan, index) in planArray" :key="index">
        <b-card-group @click="selectPlan(index)">
          <b-card
            no-body
          >
            <template #header>
              <h6 class="mb-0">{{ plan.name }}</h6>
            </template>
            <b-card-body>
              <b-card-title v-if="plan.id !== 9"><h5 style="color: #86918d">儲值 {{ plan.cash }}</h5></b-card-title>
              <b-card-sub-title v-if="plan.id !== 9 && plan.free_cash > 0"><h6 style="color: #a06f6c">額外折扣 {{ plan.free_cash }}</h6></b-card-sub-title>
              <b-card-text v-if="plan.id === 9">
                <b-input-group>
                  <b-form-input placeholder="輸入想儲值金額" type="number" v-model="planCash"></b-form-input>
                  <b-button
                    class="text-white"
                    variant="info"
                    style="background-color: #445e5b"
                    size="md"
                    @click="selectPlan(index, true)"
                    v-if="displayCashInputBtn"
                    >儲值
                  </b-button>
                </b-input-group>
              </b-card-text>
              <b-card-text v-else>
                <div v-if="plan.id === 5">
                  <span style="color: #86918d">差不多等同於</span>
                  <span class="rs-font-red">15</span>
                  <span style="color: #86918d">次服務</span>
                </div>
                <div v-if="plan.id === 6">
                  <div style="color: #86918d">
                    <span>差不多等同於</span>
                    <span class="rs-font-red">30</span>
                    <span>次服務</span>
                  </div>
                  <div style="color: #6d5049">
                    <span style="color: #bd7456">6</span>
                    <span> 個月一次定期消毒服務 (共</span>
                    <span style="color: #bd7456">2</span>
                    <span>次)</span>
                  </div>
                </div>
                <div v-if="plan.id === 7">
                  <div style="color: #86918d">
                    <span>差不多等同於</span>
                    <span class="rs-font-red">60</span>
                    <span>次服務</span>
                  </div>
                  <div style="color: #6d5049">
                    <span style="color: #bd7456">4</span>
                    <span> 個月一次定期消毒服務 (共</span>
                    <span style="color: #bd7456">3</span>
                    <span>次)</span>
                  </div>
                  <div style="color: #6d5049">
                    <span> 精油薰香/</span>
                    <span style="color: #bd7456">每次</span>
                  </div>
                </div>
                <div v-if="plan.id === 8">
                  <div style="color: #6d5049">
                    <span style="color: #bd7456">3</span>
                    <span> 個月一次定期消毒服務 (共</span>
                    <span style="color: #bd7456">4</span>
                    <span>次)</span>
                  </div>
                  <div style="color: #6d5049">
                    <span style="color: #bd7456"> 每次服務涵蓋: </span>
                    <p>精油薰香、空氣品質檢測、濕度檢測…等</p>
                  </div>
                  <div style="color: #6d5049">
                    <span> 限定執事以上等級人員前往</span>
                    <p style="color: #bd7456">通過內部多重考核，高服務品質認證</p>
                  </div>
                  <div class="rs-font-red">
                    <p>定期除塵螨，定期居家安全檢查，其他專屬客制化服務（會員護照）</p>
                  </div>
                  <div class="rs-font-red">
                    <p>未來新服務項目、保養項目（防水鍍膜、金屬保養、皮革保養）、活動優惠，皆優先體驗、安排。</p>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-card-group>
      </div>
    </div>
    <b-modal id="rsSelectTranPlan" ref="rsselecttranPplan-modal">
      <template>
        <div class="row" style="font-size: 20px">
          <div class="col-md-12">
              <h4>儲值方案確認</h4>
              <div>請確認以下方案資訊是否有誤</div>
          </div>
          <div class="col-sm-4">方案:</div>
          <div class="col-sm-8" style="color: #456361">{{ planSelectedName }}</div>
          <div class="col-sm-4">儲值金額:</div>
          <div class="col-sm-8" style="color: #456361">{{ planCash }}</div>
          <div class="col-sm-4" v-if="planFreeCash > 0"> 額外折扣 </div>
          <div class="col-sm-8" v-if="planFreeCash > 0" style="color: #445e5b">{{ planFreeCash }}</div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="dark" @click="confirmPlanCheck()" style="width:100px;">
          確認
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
          取消
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsPlanTranCheck" ref="rsplantranCheck-modal">
      <template>
        <div class="row">
          <div class="col-md-12">
            <h5>儲值資訊是否已確認無誤?</h5>
            <h5>點擊<span style="color: #AA7A72">確認</span>後將為您送出</h5>
          </div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="dark" @click="confirmPlan()" style="width:100px;">
          確認
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
          取消
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsPlanTranComplete" ref="rsplantranComplete-modal">
      <template>
        <div class="row" style="font-size: 20Px">
          <div class="col-md-12">
            <h4>匯款資訊</h4>
            <div>
              <span>方案:</span>
              <span style="color: #456361">{{ planSelectedName }}</span>
            </div>
            <div>
              <span>儲值金額:</span>
              <span style="color: #456361">{{ planCash }}</span>
            </div>
            <div v-if="planFreeCash > 0">
              <span>額外折扣:</span>
              <span style="color: #456361">{{ planFreeCash }}</span>
            </div>
            <hr>
            <div>請於時間內匯款至以下帳戶:</div>
            <div><b style="color: #AA7A72">{{ this.companyBank }}</b></div>
            <div><b>{{ this.companyBankName }}</b><b style="color: #456361">{{ this.companyBankCode }}</b></div>
            <b-button
              size="sm" variant="secondary"
              @click="copyCompanyAccount"
            >
              <b-icon icon="files" aria-hidden="true"></b-icon>
              複製帳戶
            </b-button>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button size="sm" variant="dark" @click="goToProfile()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'TransferPlanPage',
  props: {
    userId: String,
    planInfo: Object
  },
  data () {
    return {
      planArray: [],
      planSelectedName: null,
      planSelectedId: null,
      planCash: 0,
      planFreeCash: 0,
      displayCashInputBtn: false,
      inputOrderId: null,
      // defaut value
      companyBankName: '土地銀行',
      companyBankCode: '005',
      companyAccount: '144001022948'
    }
  },
  created () {
    this.$nextTick(() => {
      this.updateValueInfo()
      this.getPlan()
    })
  },
  methods: {
    getPlan () {
      const self = this
      const url = this.$apiDoc.apiGetTransferPlan
      if (!this.$parent.isLoadShow) {
        this.$parent.isLoadShow = true
      }
      this.$api.get(url).then((resp) => {
        if (resp.result && resp.data) {
          self.planArray = self.arrangePlanList(resp.data)
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.log(errorInfo)
        self.$parent.isLoadShow = false
      })
    },
    arrangePlanList (array) {
      var finalArray = []
      var freePlanIndex = -1
      var freePlan
      if (array) {
        freePlanIndex = array.findIndex((item) => {
          return item.id === 9
        })
        if (freePlanIndex >= 0) {
          freePlan = array.splice(freePlanIndex, 1)
        }
        finalArray = array
        if (freePlan) {
          finalArray = finalArray.concat(freePlan)
        }
      }
      return finalArray
    },
    selectPlan (index, fromKey) {
      const selected = this.planArray[index]
      var checkInput = this.planInfo.cash ? this.planInfo.cash : 2000
      var errorMsg = '儲值金額至少需要' + checkInput + '元'
      if (selected.id !== 9 || (this.displayCashInputBtn && selected.id && fromKey)) {
        if (selected.id === 9 && this.planCash < checkInput) {
          this.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        } else {
          this.planSelectedId = selected.id
          this.planSelectedName = selected.name
          if (selected.id === 9) {
            this.planFreeCash = 0
          } else {
            this.planCash = selected.cash
            this.planFreeCash = selected.free_cash
          }
          this.displayCashInputBtn = false
          this.$bvModal.show('rsSelectTranPlan')
        }
      } else {
        this.displayCashInputBtn = true
      }
    },
    updateValueInfo () {
      const routeInfo = this.$store.getters.getRouteInfo
      if (routeInfo.id) {
        this.inputOrderId = routeInfo.id
      }
    },
    confirmPlanCheck () {
      this.$bvModal.show('rsPlanTranCheck')
    },
    confirmPlan () {
      const self = this
      const options = {
        line_user_id: this.userId,
        top_up_plan_id: this.planSelectedId,
        cash: this.$toolDoc.turnToNumber(this.planCash),
        free_cash: this.$toolDoc.turnToNumber(this.planFreeCash),
        order_id: this.planInfo.orderId ? this.planInfo.orderId : null
      }
      var errorMsg = '不好意思， 發生預期外的錯誤，可能是網路問題，麻煩稍後再嘗試'
      this.$parent.isLoadShow = true
      self.$bvModal.hide('rsPlanTranCheck')
      this.$api.post(this.$apiDoc.apiPostTransferPlan, options).then((resp) => {
        if (resp.result && resp.data) {
          self.checkTransferCode()
          // self.$bvModal.show('rsPlanTranComplete')
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.log(errorInfo)
        errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
        console.log('errorMsg', errorMsg)
        self.$parent.isLoadShow = false
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      })
    },
    goToProfile () {
      const pt = '/customer/transfer/profile'
      this.$router.push({ path: pt, replace: true })
    },
    checkTransferCode () {
      const pt = '/customer/transfer/transfercode'
      this.$router.push({ path: pt, replace: true })
    },
    copyCompanyAccount () {
      const self = this
      navigator.clipboard.writeText(this.companyAccount).then(() => {
        self.$bvToast.toast('成功複製帳號', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        })
      })
    }
  }
}
</script>
